export default "notifications-alert .notifier__notification {\n  background-color: white !important;\n  color: black !important;\n}";